export const SectionIntro = ({ eyebrow, title, description, testId }) => {
  return (
    <div className="max-w-3xl space-y-4" data-testid={testId}>
      <p className="section-label" data-testid={`${testId}-eyebrow`}>
        {eyebrow}
      </p>
      <h2 className="text-4xl font-light tracking-tight text-foreground md:text-5xl" data-testid={`${testId}-title`}>
        {title}
      </h2>
      <p className="body-copy max-w-2xl" data-testid={`${testId}-description`}>
        {description}
      </p>
    </div>
  );
};